import { Box } from "@repo/components/src/ui/box";
import { HStack } from "@repo/components/src/ui/hstack";
import React, { useCallback } from "react";
import { ProfileBodyProps } from "../types";
import Application from "./application";
import BrandActivity from "./brand-activity";
import GeneralData from "./generalData";
import ProfileInstagram from "./instagram";
import ProfileNiches from "./niches";
import Reviews from "./reviews";
import ProfileTikTok from "./tiktok";
import WorkOrder from "./work-order";

const ProfileBody = React.memo((props: ProfileBodyProps) => {
  const renderTabContent = useCallback(() => {
    switch (props.activeTab) {
      case "instagram":
        return <ProfileInstagram key={"instagram"} {...props} />;

      case "tiktok":
        return <ProfileTikTok key={"tiktok"} {...props} />;

      case "niches":
        return <ProfileNiches key={"niches"} {...props} />;

      case "reviews":
        return <Reviews key={"reviews"} {...props} />;

      case "brand-activity":
        return <BrandActivity key={"brand-activity"} {...props} />;

      case "application":
        return <Application key={"application"} {...props} />;

      case "work-order":
        return <WorkOrder key={"work-order"} {...props} />;

      default:
        return <></>;
    }
  }, [props]);
  return (
    <HStack space="md">
      <Box className="flex-1 shrink">{renderTabContent()}</Box>
      <GeneralData {...props} />
    </HStack>
  );
});

ProfileBody.displayName = "ProfileBody";

export default ProfileBody;
